import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Checkbox,
  Typography,
  Paper,
} from "@mui/material";

const permissions = [
  "View only",
  "Create",
  "Edit",
  "Override",
  "Delete",
  "All",
];
const modules = ["Helix", "Halo", "Ignite", "Iris", "Klarity"];

export default function PermissionTable() {
  const [selectedPermissions, setSelectedPermissions] = React.useState(
    modules.reduce((acc, module) => {
      acc[module] = permissions.reduce((permAcc, perm) => {
        permAcc[perm] = false;
        return permAcc;
      }, {});
      return acc;
    }, {})
  );

  const handleChange = (module, perm) => {
    setSelectedPermissions((prev) => ({
      ...prev,
      [module]: {
        ...prev[module],
        [perm]: !prev[module][perm],
      },
    }));
  };

  const handleSelectAll = (module) => {
    const allSelected = !Object.values(selectedPermissions[module]).every(
      Boolean
    );
    setSelectedPermissions((prev) => ({
      ...prev,
      [module]: permissions.reduce((permAcc, perm) => {
        permAcc[perm] = allSelected;
        return permAcc;
      }, {}),
    }));
  };

  return (
    <TableContainer component={Paper}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>
              <Typography fontWeight="bold">Permissions</Typography>
            </TableCell>
            {permissions.map((perm) => (
              <TableCell key={perm} align="center">
                <Typography fontWeight="bold">{perm}</Typography>
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {modules.map((module) => (
            <TableRow key={module}>
              <TableCell>
                <Typography fontWeight="bold">{module}</Typography>
              </TableCell>
              {permissions.map((perm) => (
                <TableCell key={perm} align="center">
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <Checkbox
                      checked={
                        perm === "All"
                          ? Object.values(selectedPermissions[module]).every(
                              Boolean
                            )
                          : selectedPermissions[module][perm]
                      }
                      onChange={() =>
                        perm === "All"
                          ? handleSelectAll(module)
                          : handleChange(module, perm)
                      }
                      color="secondary"
                    />
                    <Typography
                      variant="body2"
                      style={{
                        marginLeft: "8px",
                      }}
                    >
                      Yes
                    </Typography>
                  </div>
                </TableCell>
              ))}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
